import { Col, Grid, Row } from "antd";
import ConectionLogo from "../Logo/Logo-conection";
import "./MenuBar.scss";
import MenuOptions from "./MenuOptions";
import ConnectionRequestList from "../Forms/Modal/ConnectionRequestList/ConnectionRequestList";
import { useState } from "react";
import { HomeFilled, HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

interface Props {
  data?: User;
}

interface User {
  username: string;
  email: string;
  role: string;
  image: string;
}

const MenuBar = (props: Props) => {
  const [notificationsVisible, setNotificationVisible] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="header-bar">
      <Row>
        <ConnectionRequestList
          sended={[]}
          received={[]}
          onOk={(value: any) => {
            setNotificationVisible(!notificationsVisible);
          }}
          open={notificationsVisible}
          onCancel={() => {
            setNotificationVisible(!notificationsVisible);
          }}
        />
        <Col className="header-columns-left" xs={24} sm={12} md={6} lg={4}>
          <ConectionLogo />
          <HomeFilled
            onClick={() => {
              navigate(`/events-listing`);
            }}
            style={{
              fontWeight: "bolder",
              cursor: "pointer",
              fontSize: "24px",
              color: "#ff974d",
            }}
          />
        </Col>
        <Col
          className="header-columns-right menu-content"
          xs={24}
          sm={12}
          md={6}
          lg={20}
        >
          <MenuOptions
            onClickNotifications={() =>
              setNotificationVisible(!notificationsVisible)
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default MenuBar;
